import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputBaseModel } from '../../models';
import { InputRenderer } from '../../components';
import { NodeProps } from '../../componentTypes';
import { LayoutRenderer } from '../../layout_renderers';
import { InputIds, NodeIds } from '../../misc';
import { Utils } from '../../../custom_shared/misc';
import { useNodeForm } from '../../hooks';
import { GetComponentRowsFunction } from '../../componentTypes';
import { ColumnSpan } from '../../types';
import { InputComponentRegistry } from '../../node_inputs';

const InputComponents = InputComponentRegistry[NodeIds.Classifications];

const InputColumnSpans: Record<string, ColumnSpan> = {
    [InputIds.Classifications.MainClass]: 24,
    [InputIds.Classifications.Class]: 24,
    [InputIds.Classifications.SubClass]: 24
};

const ClassificationsNodeRenderer: React.FC<NodeProps> = ({ node }: NodeProps) => {
    const { form, formKey, onValuesChange } = useNodeForm(node);

    const getComponentRows: GetComponentRowsFunction = React.useCallback(
        (inputs: InputBaseModel[]) =>
            Utils.groupArray(inputs, 1).map(inputGroup =>
                inputGroup.map(input => ({
                    component: (
                        <InputRenderer
                            key={input.id}
                            input={input}
                            component={InputComponents[input.id as keyof typeof InputComponents]}
                        />
                    ),
                    columnSpan: InputColumnSpans[input.id]
                }))
            ),
        []
    );

    return (
        <LayoutRenderer
            node={node}
            form={form}
            formKey={formKey}
            onValuesChange={onValuesChange}
            getComponentRows={getComponentRows}
        />
    );
};

export default observer(ClassificationsNodeRenderer);
